import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import { TCalendarDate } from "../../../../components/commons/ono-calendar-v2/calendar_types";
import { TCustomerInfo } from "../../payouts/bloc/payoutsSlice";

export type TCollectionsFilters = {
  selectedModes: string[];
  selectedStatuses: string[];
  selectedCustomers: string[];
};

type TinitialState = {
  calendarDate: TCalendarDate;
  collections: TCollectionInfo[];
  selectedCollectionId: string;
  filters: TCollectionsFilters;
  customers: TCustomerInfo[];
};

export type TCollectionInfo = {
  utr: string;
  createdOn: string;
  customer: string;
  paymentSource: string;
  amount: number;
  status: string;
  prodId: string;
};

const initialState: TinitialState = {
  calendarDate: {
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
    mode: "MONTHLY",
  },
  collections: [],
  selectedCollectionId: "",
  filters: {
    selectedModes: [],
    selectedStatuses: ["SUCCESS"],
    selectedCustomers: [],
  },
  customers: [],
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState: initialState,
  reducers: {
    setCollections: (
      state,
      action: PayloadAction<{
        collections: TCollectionInfo[];
      }>,
    ) => {
      state.collections = action.payload.collections;
    },
    setCustomers: (
      state,
      action: PayloadAction<{
        customers: TCustomerInfo[];
      }>,
    ) => {
      state.customers = action.payload.customers;
    },
    setCalendarDate: (
      state,
      action: PayloadAction<{
        calendarDate: TCalendarDate;
      }>,
    ) => {
      state.calendarDate = action.payload.calendarDate;
    },
    setCollectionId: (
      state,
      action: PayloadAction<{
        collectionId: string;
      }>,
    ) => {
      state.selectedCollectionId = action.payload.collectionId;
    },
    setSelectedFilters: (
      state,
      action: PayloadAction<{
        selectedModes: string[];
        selectedStatuses: string[];
        selectedCustomers: string[];
      }>,
    ) => {
      state.filters.selectedModes = action.payload.selectedModes;
      // state.filters.selectedStatuses = action.payload.selectedStatuses;
      state.filters.selectedStatuses =
        action.payload.selectedStatuses.length > 0
          ? action.payload.selectedStatuses
          : ["SUCCESS"];
      state.filters.selectedCustomers = action.payload.selectedCustomers;
    },
  },
});

export const {
  setCollections,
  setCustomers,
  setCalendarDate,
  setCollectionId,
  setSelectedFilters,
} = collectionsSlice.actions;
export default collectionsSlice.reducer;
